import React from "react";
import ConnectToInternet from "../../reusable/ConnectToInternet";
import StayTouch from "../../layout/StayTouch";
import layoutWrapper from "../../components/Hoc/layoutWrapper";
import AnyQuestions from "../../reusable/AnyQuestions";
import BlackTitleBar from "../getwifius/BlackTitleBar";
import RechargeDeviceCart from "./RechargeDevice";
import RechargeSubNavi from "./RechargeSubNavi";
import RechargeDeviceBanner from "../../reusable/RechargeDeviceBanner";


class RechargeDevice extends React.Component {
    render(){
        return(
            <div>
                <RechargeDeviceBanner />
                {/*<RechargeSubNavi />*/}
                <RechargeDeviceCart />
                <AnyQuestions />
                <StayTouch />
            </div>
        );
    }
}

export default layoutWrapper(RechargeDevice);



// WEBPACK FOOTER //
// ./src/pages/rechargeDevice/index.js